<template>
  <div>
    <div @click="openModal" data-bs-toggle="modal" :data-bs-target="`#modal-${label}`" class="position-relative">
      <span v-if="selected.iso2 !== ''" class="flag input-flag" :class="selected.iso2.toLowerCase()" />
      <input label="País" class="form-control form-control-sm" style="padding-left: 30px !important; cursor:pointer; min-width:75px" :value="dialCode" :readonly="true" :disabled="disabled"/>
    </div>

    <modal :id="`modal-${label}`" :custom-classes="['modal-dialog-centered', 'modal-md']" title="Escolher País" >
      <template #body>
        <div>
          <div class="header">
            <div>Buscar</div>
          </div>

          <div class="d-flex search">
            <input
              type="text"
              placeholder="Digite o código ou nome do país"
              :value="search"
              @input="e => search = e.target.value"
              class="form-control form-control-sm" 
              autocomplete="nope"
              autocapitalize="nope"
              autoCorrect="nope"
              name="test"
              v-focus
              @keydown.down="selectDown"
              @keydown.up="selectUp"
              @keydown.enter="close"
            >
          </div>

          <hr class="mb-2" />

          <div class="d-flex flex-column justify-content-between align-items-center">
            <div class="multiselect-body">
              <div id="multiselect-container">
                <ul class="items" id="items-list">
                  <li v-for="(option, index) in countriesFilter" :key="index" @click="select(option)" :class="{selected: selected.iso2 === option.iso2}">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center gap-1">
                        <span class="flag" :class="option.iso2.toLowerCase()"></span>
                        <span class="description ml-3" v-html="highlight(option.name)"></span>
                      </div>

                      <span class="mr-2" v-html="highlight(`+${option.dialCode}`)"></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>       
    </modal>

  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {countries} from "@/components/shared/phone/assets/countyCodes";
import {parsePhoneNumberFromString} from "libphonenumber-js";
import {Modal as bsModal} from "bootstrap";
import Modal from "@/components/shared/Modal.vue";

export default {
  name: 'phone-country-selector',
  components: {Modal},
  props: {
    value: {type: Object, default: {}},
    disabled: {type: Boolean, default: false},
    label: { type: String, default: 'Telefone' },
  },
  data() {
    return {
      show: false,
      search: '',
      countries: countries,
      selected: {
        iso2: '',
        dialCode: ''
      },
      modal: null
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  mounted() {
    this.modal = bsModal.getOrCreateInstance(document.getElementById(`modal-${this.label}`));
  },
  methods: {
    selectDown() {
      let index = this.countriesFilter.indexOf(this.selected);
      if (index === this.countriesFilter.length - 1) {
        return false;
      }

      this.selected = this.countriesFilter[index + 1];

      let selected = document.querySelector('.selected');
      let container = document.querySelector('#multiselect-container');

      if(index >= 11 && container) {
        container.scrollTop = container.scrollTop + selected.getBoundingClientRect().height;
      }
    },
    selectUp() {
      let index = this.countriesFilter.indexOf(this.selected);

      if (index <= 0) {
        return false;
      }

      this.selected = this.countriesFilter[index - 1];

      let selected = document.querySelector('.selected');
      let container = document.querySelector('#multiselect-container');

      if(index <= 11 && container) {
        container.scrollTop = 0;
      } else if(container) {
        container.scrollTop = container.scrollTop - selected.getBoundingClientRect().height ;
      }
    },
    openModal() {
      if(!this.disabled) {
        this.search = '';
        this.show = true;
      }
    },
    close() {
      if (this.show) {
        this.$root.$emit('clear-modal-header', false);
        this.show = false;
        this.$emit('input', this.selected);
      }
    },
    select(option) {
      this.selected = option;
      this.close();
    },
    highlight(text) {
      let search = this.search.replace('+', '\\+');
      return text.replace(new RegExp(search + '(?!([^<]+)?<)', 'gi'), '<strong>$&</strong>');
    }
  },
  computed: {
    ...mapGetters('ui', ['isIOS']),
    dialCode() {
      if(this.selected.dialCode !== '') {
        return `+${this.selected.dialCode}`;
      }

      return '';
    },
    countriesFilter() {
      return this.countries.filter((item) => {
        let searchOption = item.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        let searchString = this.search.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        let searchCode = `+${item.dialCode}`;

        return searchOption.toLowerCase().includes(searchString.toLowerCase()) || searchCode.includes(searchString.toLowerCase())
      })
    }
  },
  watch: {
    show() {
      if(this.show) {
        this.$nextTick(() => {
          let container = document.querySelector('#multiselect-container');
          let index = this.countriesFilter.indexOf(this.selected);

          if(index <= 11) {
            container.scrollTop = 0;
          } else {
            container.scrollTop = container.scrollTop + (index * 30);
          }

        })
      }
    },
    value: {
      handler () {
        this.$nextTick(() => {
          let country = this.countries.find((item) => {
            return item.iso2 === this.value.iso2
          });

          if(country) {
            this.selected = country;
          }

        })
      },
      immediate: true
    }
  }

}
</script>
<style scoped lang="scss">
  @import "./assets/flags.css";
  .form-phone-container {
    display: grid;
    grid-row-gap: .6rem;
    grid-column-gap: .6rem;
    grid-template-columns: 1fr 2fr;
  }

  .modal-overlay {
    background: rgba(0, 0, 0, 0.7);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    -webkit-transition: opacity 400ms ease-in;
    -moz-transition: opacity 400ms ease-in;
    transition: opacity 400ms ease-in;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    pointer-events: auto;
    z-index: 9999;
    overflow: hidden;
    @media (max-width: 769px) {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background-color: #fff;
    }

    .sub100-modal {
      background-color: var(--white);
      position: relative;
      margin: 0 auto;
      border-radius: 0;
      overflow-y: scroll;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      max-width: auto;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
      overflow: hidden;
      @media (max-width: 769px) {
        height: 100%;
        width: 100%;
      }
      @media (min-width: 769px) {
        margin: 5.2% auto;
        height: 502px;
        overflow-y: auto;
        width: 50%;
        max-width: 480px;
        border-radius: .32rem;
      }

      h3 {
        font-size: 1rem;
        color: #333;
      }

      .close {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        text-align: center;
        top: 9px;
        z-index: 1;
        opacity: 1;
      }

      .close svg {
        height: 15px;
        width: 15px;
        fill: var(--primary);
      }

      .title {
        font-weight: 600;
      }

      .header {
        padding: 1rem 1rem 0 1rem;
      }

      .search {
        padding: 1rem 1.5rem 0 1.5rem;
      }

      .search-input {
        border: none;
        outline: none;
        color: #333;
        font-size: .9rem;
        width: 100%;
        padding-left: 25px;
        background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' width='20px' height='20px' version='1.1' style='shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd'%0AviewBox='0 0 6773 6773' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cstyle type='text/css'%3E%3C!%5BCDATA%5B .fil0 %7Bfill:%23AAACAF%7D %5D%5D%3E%3C/style%3E%3C/defs%3E%3Cg id='Camada_x0020_1'%3E%3Cmetadata id='CorelCorpID_0Corel-Layer'/%3E%3Cpath class='fil0' d='M923 923c1030,-1030 2700,-1030 3730,0 963,963 1026,2484 189,3520l1732 1732c65,65 66,173 0,238l-161 161c-66,66 -174,65 -238,0l-1732 -1732c-1036,837 -2557,774 -3520,-189 -1030,-1030 -1030,-2700 0,-3730zm399 399c810,-810 2122,-810 2932,0 810,810 810,2122 0,2932 -810,810 -2122,810 -2932,0 -810,-810 -810,-2122 0,-2932z'/%3E%3C/g%3E%3C/svg%3E") no-repeat;
      }
    }
  }

  #multiselect-container {
    overflow-y: auto;
    max-height: 300px;
    min-height: 300px;
    @media (max-width: 769px) {
      min-height: initial;
      max-height: initial;
      height: calc(100vh - 170px);
    }
  }

  .multiselect-body {
    width: 100%;
    padding: 0 .5rem 0 1rem;
  }

  .items {
    list-style-type: none;
    padding: 0;
  }

  .items li {

    color: #333;
    font-size: 14px;
    cursor: pointer;
    padding: 5px;
    box-sizing: border-box;
    border-radius: .32rem;
  }

  .items li.selected {
    background: var(--background-business-type);
  }

  .items li:hover {
    background: var(--background-business-type);
  }

  .input-flag {
    position: absolute;
    top: 7px;
    left: 7px;
    cursor: pointer;
  }
</style>
